<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='titleIcon'
      showEdit
      @edit='editBasics'
    >
      <v-card-text>
        <span class='grey--text'>Name:</span><br>
        <h3>{{ template.name }}</h3>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      v-if='templateCopy'
      :showDialog='showEditDialog'
      :title='title'
      :icon='titleIcon'
      @cancel='cancelEdit'
      @save='saveTemplateName'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='Template Name'
          v-model='templateCopy.name'
          ref='Tname'>
        </v-text-field>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'template-basics',
  props: {
    template: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showEditDialog: false,
    templateCopy: {},
    title: 'Basics',
    titleIcon: 'mdi-information-outline'
  }),
  computed: {
    basicsTable () {
      return [
        { text: 'Hold Invoices?', value: this.$options.filters.trueFalse(this.template.hold_invoices) }
      ]
    }
  },
  methods: {
    editBasics () {
      this.templateCopy = _.cloneDeep(this.template)
      this.showEditDialog = true
      setTimeout(() => {
        this.$refs.Tname.focus()
      }, 100)
    },
    cancelEdit () {
      this.showEditDialog = false
    },
    saveTemplateName () {
      this.$emit('update', this.templateCopy)
      this.showEditDialog = false
    }
  }
}
</script>
